var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partly-Cloudly",
    transform: "translate(0 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167390",
    "data-name": "Path 167390",
    d: "M33.171,42.787H10.342a11.294,11.294,0,0,1-7.174-2.231A8.811,8.811,0,0,1,0,33.4,8.653,8.653,0,0,1,2.843,26.81,11.277,11.277,0,0,1,8.6,24.165c.006,0,.008,0,.008-.006a15.921,15.921,0,0,1,4.908-9.43,13.6,13.6,0,0,1,9.12-3.479,12.9,12.9,0,0,1,7.972,2.677,14,14,0,0,1,4.116,5.244,1.564,1.564,0,0,0,1.092.887,12.652,12.652,0,0,1,6.358,3.351,10.907,10.907,0,0,1,3.1,7.866,11.145,11.145,0,0,1-3.61,8.33A12.464,12.464,0,0,1,33.171,42.787ZM35.025,19.905Z",
    transform: "translate(0 3.463)",
    fill: "#b1b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167391",
    "data-name": "Path 167391",
    d: "M30.335,18.685a16.636,16.636,0,0,1,3.426,1.449.394.394,0,0,0,.573-.241A9.475,9.475,0,0,0,25.228,7.874,9.408,9.408,0,0,0,19.8,9.584h-.006a.334.334,0,0,0,.1.592,16.01,16.01,0,0,1,5.054,2.6,17.141,17.141,0,0,1,4.467,5.175,1.577,1.577,0,0,0,.921.733Z",
    transform: "translate(7.537 2.221)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167392",
    "data-name": "Path 167392",
    d: "M36.231,16.654H33.077a1.577,1.577,0,1,1,0-3.154h3.154a1.577,1.577,0,1,1,0,3.154Z",
    transform: "translate(12.193 4.46)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167393",
    "data-name": "Path 167393",
    d: "M24.077,8.557A1.577,1.577,0,0,1,22.5,6.981V3.827a1.577,1.577,0,0,1,3.154,0V6.981A1.577,1.577,0,0,1,24.077,8.557Z",
    transform: "translate(8.731)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167394",
    "data-name": "Path 167394",
    d: "M18.352,10.929a1.568,1.568,0,0,1-1.114-.463l-2.23-2.229a1.577,1.577,0,0,1,2.23-2.23l2.229,2.23a1.577,1.577,0,0,1-1.114,2.691Z",
    transform: "translate(5.634 1.324)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167395",
    "data-name": "Path 167395",
    d: "M30.44,10.929a1.577,1.577,0,0,1-1.114-2.691l2.229-2.23a1.577,1.577,0,1,1,2.23,2.23l-2.23,2.229a1.568,1.568,0,0,1-1.114.463Z",
    transform: "translate(11.134 1.324)",
    fill: "#f6be00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudy);
export default __webpack_public_path__ + "static/media/partly-cloudy.4780030620f781f2e0f530bcac597d27.svg";
export { ForwardRef as ReactComponent };